import { remarkList } from "constants/remark";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getRemarkList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.remark_list(pageNum, filters);
    dispatch({ type: remarkList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: remarkList,
      payload: error?.response?.data || error,
    });
  }
};
